export default "__VITE_ASSET__iaIhhkkw__"